import {
  INSERT_THUMB_TYPE_BLANK,
  INSERT_THUMB_TYPE_TURBO_URETHANE_THUMB_SLUG,
  INSERT_THUMB_TYPE_TURBO_XCEL_SOLID,
  INSERT_THUMB_TYPE_TURBO_XCEL_ROUND,
  INSERT_THUMB_TYPE_TURBO_XCEL_OVAL,
  INSERT_THUMB_TYPE_ULTIMATE_URETHANE_SLUG,
  INSERT_THUMB_TYPE_ULTIMATE_THUMB,
  INSERT_THUMB_TYPE_TURBO_SWITCH_GRIP,
  INSERT_THUMB_TYPE_VISE_ULTIMATE_VINYL,
  INSERT_THUMB_TYPE_VISE_PRO_V2,
  INSERT_THUMB_TYPE_VISE_IT,
  INSERT_THUMB_TYPE_VISE_EASY_URETHANE_SLUG,
  INSERT_THUMB_TYPE_VISE_VINYL_SLUG,
} from './idx_data_thumb_insert_types';

export const idx_data_thumb_insert_types = [];

idx_data_thumb_insert_types.push({
  id: INSERT_THUMB_TYPE_BLANK,
  type: '',
  select_size: true,
  select_od: true,
});

idx_data_thumb_insert_types.push({
  id: INSERT_THUMB_TYPE_TURBO_URETHANE_THUMB_SLUG,
  type: 'Turbo Urethane Thumb Slug',
  select_size: true,
  select_od: true,
});

idx_data_thumb_insert_types.push({
  id: INSERT_THUMB_TYPE_TURBO_XCEL_SOLID,
  type: 'Turbo Xcel Solid',
  select_size: true,
  select_od: true,
});

idx_data_thumb_insert_types.push({
  id: INSERT_THUMB_TYPE_TURBO_XCEL_ROUND,
  type: 'Turbo Xcel Round',
});

idx_data_thumb_insert_types.push({
  id: INSERT_THUMB_TYPE_TURBO_XCEL_OVAL,
  type: 'Turbo Xcel Oval',
});

idx_data_thumb_insert_types.push({
  id: INSERT_THUMB_TYPE_ULTIMATE_URETHANE_SLUG,
  type: 'Ultimate Urethane Slug',
  select_size: true,
  select_od: true,
});

idx_data_thumb_insert_types.push({
  id: INSERT_THUMB_TYPE_ULTIMATE_THUMB,
  type: 'Ultimate Thumb',
  select_size: true,
  select_od: true,
});

idx_data_thumb_insert_types.push({
  id: INSERT_THUMB_TYPE_TURBO_SWITCH_GRIP,
  type: 'Turbo Switch Grip',
  select_size: true,
  select_od: true,
});

idx_data_thumb_insert_types.push({
  id: INSERT_THUMB_TYPE_VISE_ULTIMATE_VINYL,
  type: 'Vise Ultimate Vinyl',
});

idx_data_thumb_insert_types.push({
  id: INSERT_THUMB_TYPE_VISE_PRO_V2,
  type: 'Vise Pro V2',
});

idx_data_thumb_insert_types.push({
  id: INSERT_THUMB_TYPE_VISE_IT,
  type: 'Vise IT',
  select_size: true,
  select_od: true,
});

idx_data_thumb_insert_types.push({
  id: INSERT_THUMB_TYPE_VISE_EASY_URETHANE_SLUG,
  type: 'Vise Easy Urethane Slug',
  select_size: true,
  select_od: true,
});

idx_data_thumb_insert_types.push({
  id: INSERT_THUMB_TYPE_VISE_VINYL_SLUG,
  type: 'Vise Vinyl Slug',
  select_size: true,
  select_od: true,
});
